export function normalizeHtmlText(value) {
  if (!value) return ''

  return String(value).replace(/&nbsp;/g, '\u00A0')
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/string.js